import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user:{
      token:``,
      buaaId: 0,
      role:0,
      name:'',
      isLogin: false,
    },
    // user:{
    //   token:`eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIxMjMiLCJuYW1lIjoi5L2V57-UIiwiZXhwIjoxNzE5Mjk2OTY4LCJpYXQiOjE3MTQ5NzY5NjgsImpvYk51bWJlciI6IjEyMyJ9.KwekGTDKV2yhfqGW98N-O996nKJVE8Vy9o5aIrKyLIg`,
    //   buaaId: 2,
    //   role:2,
    //   name:'hexiang开发版本',
    //   isLogin: true,
    // },
    exerciseIndex:0,//1是顺序练习，2是错题练习，3是智能练习，4是审核题目，5是模拟考试，6是查看历史考试,7是教师组卷,8是收藏题练习
  },
  getters: {
  },
  mutations: {
    changeExerciseIndex(state,payload){
      state.exerciseIndex = payload
    },
    savaToken(state,payload){
      state.user.token = payload
    },
    savabuaaId(state,payload){
      state.user.buaaId = payload
    },
    savaRole(state,payload){
      state.user.role = payload
    },
    savaIsLogin(state,payload){
      state.user.isLogin = payload
    },
    logOut(state,payload){
      state.user={
        token:``,
        buaaId: 0,
        role:0,
        name:'',
        isLogin: false,
      }
    }
  },
  actions: {
  },
  modules: {
  }
})
